import { MoonIcon, PersonSimpleWalkIcon } from "@phosphor-icons/react";
import clsx from "clsx";
import { useIntl } from "react-intl";

import { parseDuration } from "@/utils/duration";

type Props = {
  stopTime: string;
  cityName: string;
  isOvernight: boolean;
};

export const TransferBar = ({ stopTime, cityName, isOvernight }: Props) => {
  const intl = useIntl();

  return (
    <div
      className={clsx("flex w-full justify-between rounded-xl p-3 text-sm", {
        "bg-surface-background": !isOvernight,
        "bg-semantic-error-soft": isOvernight,
        "border-1": isOvernight,
        "border-semantic-error-medium": isOvernight,
      })}
    >
      <span className="text-text-tertiary">
        {intl.formatMessage({ id: "durationValue" }, parseDuration(stopTime))}
      </span>
      <span className="flex items-center gap-1 font-medium text-text-primary">
        {isOvernight
          ? intl.formatMessage({ id: "flights.nightFlightStop" }, { cityName })
          : intl.formatMessage({ id: "flights.flightStop" }, { cityName })}
        {isOvernight ? (
          <div className="text-semantic-error-strong">
            <MoonIcon size={20} weight="bold" />
          </div>
        ) : (
          <PersonSimpleWalkIcon size={20} />
        )}
      </span>
    </div>
  );
};
